type Tone = "green" | "amber" | "red" | "gray";

export function StatusDot({
  tone,
  pulse = false,
  label,
}: {
  tone: Tone;
  pulse?: boolean;
  label?: string;
}) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      <span className={`dot dot-${tone}${pulse ? " pulse" : ""}`} />
      {label ? <span className="status-dot-label">{sentenceCase(label)}</span> : null}
    </span>
  );
}

function sentenceCase(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
